import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import store from "./store";
import 'element-ui/lib/theme-chalk/index.css'
import './permission' // 权限控制
import './styles/index.scss' // 全局样式

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 